var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"icon - right arrow link - 12px"},[React.createElement("path",{"style":{"fill":"none"},"d":"M0 0h12v12H0z","key":0}),React.createElement("path",{"data-name":"↳color","d":"m14.588 134.884-2.744-2.731a.525.525 0 0 0-.741.744l1.842 1.833h-7.42a.525.525 0 0 0 0 1.05h7.42l-1.845 1.834a.525.525 0 0 0 .741.744l2.744-2.731a.526.526 0 0 0 .003-.743z","transform":"translate(-3.871 -129.256)","style":{"fill":"#031425"},"key":1})]));
}

ArrowRight.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
